<div class="st-drawer-wrapper">
  <a href=""></a>
  <!--  Header  -->
  <div class="st-drawer-header">
    <span *ngIf="step !== 3" class="text-header-18 text-semibold">Editar flujo de "{{ ps.selectedService?.name }}"</span>
    <div *ngIf="step === 3" class="st-header-inner-group flex-center gap-100">
      <button (click)="cancelAddOrEditEvent()" nz-button nzType="text" nzSize="default" nzShape="circle"
              class="text-btn-16">
        <app-st-icon class="flex-center" [bold]="true" name="arrow_back"></app-st-icon>
      </button>
      <span *ngIf="selectedEvent?.name" class="text-header-18 text-semibold">Editar Evento "{{ selectedEvent?.name }}"</span>
      <span *ngIf="!selectedEvent" class="text-header-18 text-semibold">Añadir Evento</span>
    </div>
    <app-st-icon *ngIf="step !== 3" (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'"
                 [bold]="true"></app-st-icon>
  </div>

  <!--  Content  -->
  <div class="st-drawer-content">
    <!--  Contenido de Flujo  -->
    <div *ngIf="step === 2" class="flow-content-wrapper">
      <!-- Select para seleccionar el flujo -->
      <div class="w-100 flex flex-column gap-150">
        <label class="text-label-10">Flujo</label>
        <nz-select [nzSuffixIcon]="customSelectIcon" nzSize="large" nzShowSearch [ngModel]="selectedFlow"
                   (ngModelChange)="setEvents($event)">
          <nz-option *ngFor="let flow of flowsList" [nzLabel]="flow.name" [nzValue]="flow"></nz-option>
        </nz-select>
      </div>

      <!-- Lista de eventos del flujo dado -->
      <app-event-cards-dragables *ngIf="eventsToEdit"
        [events]="eventsToEdit"
        (openAddOrEditEvent)="openAddOrEditEvent($event)"
      ></app-event-cards-dragables>
    </div>

    <!--  Contenido de Eventos y Activator  -->
    <app-event-activator-section *ngIf="step === 3 && eventsToEdit"
                                 [event]="selectedEvent"
                                 [eventsLenght]="eventsToEdit.length"
                                 [(activatorForm)]="activatorForm"
                                 [(eventForm)]="eventForm"
    ></app-event-activator-section>

  </div>

  <!--  Footer  -->
  <div class="st-drawer-footer" [class.show-border]="step !== 1">
    <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">Cancelar
    </button>

    <div *ngIf="step === 2" class="flex gap-200">

      <button (click)="editFlow()"
              class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
        <app-st-icon *ngIf="!editingFlow" class="prefix" [name]="'edit'" [bold]="true"></app-st-icon>
        <app-st-icon *ngIf="editingFlow" class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
        <span>Editar flujo</span>
      </button>
    </div>

    <button *ngIf="step === 3" [disabled]="!isFormsValids()" (click)="confirmAddOrEditEvent()"
            class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
      <span>{{ selectedEvent ? 'Editar' : 'Añadir' }} Evento</span>
    </button>
  </div>
</div>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>

<!--  Notification  -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
             [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>
